/*
 * Copyright (c) 2026 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React from 'react';

const modalOverlayStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  right: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalStyle: React.CSSProperties = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '10px',
  width: '500px',
  maxHeight: '90%',
  overflowY: 'auto',
  position: 'relative',
  textShadow: 'none',
  color: 'black',
  fontFamily: 'arial',
  textAlign: 'center',
};

const buttonStyle: React.CSSProperties = {
  fontSize: 'medium',
  padding: '10px 20px',
  backgroundColor: '#4CAF50',
  color: 'white',
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer',
  marginTop: '20px',
  marginLeft: '10px',
  marginRight: '10px',
};

const cancelButtonStyle: React.CSSProperties = {
  ...buttonStyle,
  backgroundColor: '#999',
};

interface SubscriptionRenewalModalProps {
  isOpen: boolean;
  monsterCount: number;
  onRenew: () => void;
  onClose: () => void;
  expirationDate?: Date | null;
}

const SubscriptionRenewalModal: React.FC<SubscriptionRenewalModalProps> = ({ isOpen, monsterCount, onRenew, onClose, expirationDate }) => {
  if (!isOpen) {
    return null;
  }

  // Calculate deletion date (expiration + 90 days)
  let deletionDateStr = '90 days from expiration';
  let expirationDateStr = 'expiration date';
  let veryExpired = false;
  if (expirationDate) {
    const deletionDate = new Date(expirationDate);
    deletionDate.setDate(deletionDate.getDate() + 90);
    deletionDateStr = deletionDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    expirationDateStr = expirationDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    veryExpired = deletionDate > new Date();
  }

  return (
    <div style={modalOverlayStyle}>
      <div style={modalStyle}>
        <h2 style={{ color: '#D32F2F' }}>Subscription Expired</h2>

        <div style={{ margin: '20px 0', padding: '20px', backgroundColor: '#f8f8f8', borderRadius: '5px', textAlign: 'left' }}>
          <p>Your subscription has expired. To continue using this feature, please renew your subscription.</p>

          {monsterCount > 0 && (<>
            <p><strong>Important:</strong></p>
            <ul style={{ marginLeft: '20px' }}>
              <li>Your {monsterCount} monster{monsterCount === 1 ? ' is' : 's are'} currently stored online and will be kept for 90 days after the expiration date of {expirationDateStr}.</li>
              <li>After <strong>{deletionDateStr}</strong>, all of your monsters will be <strong>permanently deleted!</strong></li>
              <li>Renew now to regain access to all your saved monsters.</li>
            </ul>
            </>)}
          {monsterCount === 0 && veryExpired && <p>Your account has been expired for more than 90 days. Any monsters you had stored online have been deleted.</p>}
          {monsterCount === 0 && <p>Renew now to regain access to online monster storage, and the PC/NPC Creator.</p>}
        </div>

        <div>
          <button style={buttonStyle} onClick={onRenew}>Renew Subscription</button>
          <button style={cancelButtonStyle} onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionRenewalModal;
